// extracted by mini-css-extract-plugin
export default {"text-box":"text-box--vFUzughF+S","textBox":"text-box--vFUzughF+S"};